

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import UserApi from "../../../../services/UserApi.jsx";
import { separatorNumber, useGlobalFunc } from "../../../../global/constants.js";
import { MenuItem, Pagination, Select } from "@mui/material";
import { useSelector } from "react-redux";
import { isValidEmail, isValidPhoneNumber } from "../../../../global/regex.js";






// import homeshadowImg from '../../../assets/homeshadow.png'
// import homescrollImg from '../../../assets/homescroll.png'

// import homepic1Img from '../../../assets/homepic1.png'
// import homepic2Img from '../../../assets/homepic2.png'


const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);

    const userInfo = useSelector(state => state.userInfo);


    const { setLoading, successToast, errorToast, updateMe } = useGlobalFunc()
    const [totalPage, setTotalPage] = useState(1);
    const [page, setPage] = useState(1);


    const [dataList, setDataList] = useState(null)

    const [editPhone, setEditPhone] = useState(false)
    const [editAddress, setEditAddress] = useState(false)
    const [editEmail, setEditEmail] = useState(false)
    const [editLineId, setEditLineId] = useState(false)
    const [editBankName, setEditBankName] = useState(false)
    const [editBankNumber, setEditBankNumber] = useState(false)

    const [data, setData] = useState(null)

    const updateData = (i, value) => {
        setData(prevData => ({ ...prevData, [i]: value }));
    };

    async function updateUserInfo(type) {
        setLoading(true)

        try {

            let json = {}
            if (type == 'phone') {
                if (!isValidPhoneNumber(data.phone)) {
                    errorToast('請輸入正確電話格式')
                    return
                }
            }
            else if (type == 'email') {
                if (!isValidEmail(data.email)) {
                    errorToast('請輸入正確電子郵件格式')
                    return
                }
            }

            json[type] = String(data[type])

            let res = await UserApi.updateMe(json)
            console.log(res.data.data)
            updateMe()
            if (type == 'phone') {
                setEditPhone(false)
            }
            else if (type == 'email') {
                setEditEmail(false)
            }
            else if (type == 'address') {
                setEditAddress(false)
            }
            else if (type == 'lineId') {
                setEditLineId(false)
            }
            else if (type == 'bankName') {
                setEditBankName(false)
            }
            else if (type == 'bankNumber') {
                setEditBankNumber(false)
            }
            successToast('編輯成功')

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        finally {
            setLoading(false)
        }

    }


    useEffect(() => {
        setData(userInfo)
    }, [userInfo]);

    return <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
        <div className="text-lg font-bold mb-4">{t('memberCenterType.userinfo')}</div>
        {data &&
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-7">
                <div>
                    <p className="text-sm font-bold mb-2">會員編號</p>
                    <div className="input w-full" >
                        {userInfo.systemId}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">會員身份</p>
                    <div className="input w-full" >
                        {t(`grade.${userInfo.identity.name}`)}
                    </div>
                </div>
                <div className=" sm:col-span-2">
                    <p className="text-sm font-bold mb-2">帳號</p>
                    <div className="input w-full" >
                        {userInfo.accountId}
                    </div>
                </div>
                <div >
                    <p className="text-sm font-bold mb-2">姓名</p>
                    <div className="input w-full" >
                        {userInfo.name}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">生日</p>
                    <div className="input w-full" >
                        {userInfo.birthday && userInfo.birthday.slice(0, 10)}
                    </div>
                </div>
                <div>
                    <div className="flex justify-between text-sm font-bold mb-2">
                        <p className="">電話</p>
                        {
                            !editPhone ?
                                <div className=" text-main4 cursor-pointer" onClick={() => setEditPhone(true)}>
                                    編輯
                                </div>
                                :
                                <div className="flex gap-2 ">
                                    <div className=" text-black6  cursor-pointer" onClick={() => setEditPhone(false)}>
                                        取消
                                    </div>
                                    <div className=" text-main4 cursor-pointer" onClick={() => updateUserInfo('phone')}>
                                        儲存
                                    </div>
                                </div>
                        }
                    </div>
                    <div className="input w-full flex items-center ">
                        <div className="flex-none">+886 </div>

                        <input className={` border-0 min-h-[auto] !py-0 h w-full ${!editPhone && " cursor-default"}`} type="text" maxLength={10} value={data.phone} edit readOnly={!editPhone} onChange={e => updateData('phone', e.target.value)} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-between text-sm font-bold mb-2">
                        <p className="">地址</p>
                        {
                            !editAddress ?
                                <div className=" text-main4 cursor-pointer" onClick={() => setEditAddress(true)}>
                                    編輯
                                </div>
                                :
                                <div className="flex gap-2 ">
                                    <div className=" text-black6  cursor-pointer" onClick={() => setEditAddress(false)}>
                                        取消
                                    </div>
                                    <div className=" text-main4 cursor-pointer" onClick={() => updateUserInfo('address')}>
                                        儲存
                                    </div>
                                </div>
                        }
                    </div>
                    <input className={`input w-full ${!editAddress && " cursor-default"}`} value={data.address} edit readOnly={!editAddress} onChange={e => updateData('address', e.target.value)} />
                </div>
                <div>
                    <div className="flex justify-between text-sm font-bold mb-2">
                        <p className="">電子郵件</p>
                        {
                            !editEmail ?
                                <div className=" text-main4 cursor-pointer" onClick={() => setEditEmail(true)}>
                                    編輯
                                </div>
                                :
                                <div className="flex gap-2 ">
                                    <div className=" text-black6  cursor-pointer" onClick={() => setEditEmail(false)}>
                                        取消
                                    </div>
                                    <div className=" text-main4 cursor-pointer" onClick={() => updateUserInfo('email')}>
                                        儲存
                                    </div>
                                </div>
                        }
                    </div>
                    <input className={`input w-full ${!editEmail && " cursor-default"}`} value={data.email} edit readOnly={!editEmail} onChange={e => updateData('email', e.target.value)} />
                </div>
                <div>
                    <div className="flex justify-between text-sm font-bold mb-2">
                        <p className="">LINE ID</p>
                        {
                            !editLineId ?
                                <div className=" text-main4 cursor-pointer" onClick={() => setEditLineId(true)}>
                                    編輯
                                </div>
                                :
                                <div className="flex gap-2 ">
                                    <div className=" text-black6  cursor-pointer" onClick={() => setEditLineId(false)}>
                                        取消
                                    </div>
                                    <div className=" text-main4 cursor-pointer" onClick={() => updateUserInfo('lineId')}>
                                        儲存
                                    </div>
                                </div>
                        }
                    </div>
                    <input className={`input w-full ${!editLineId && " cursor-default"}`} value={data.lineId} edit readOnly={!editLineId} onChange={e => updateData('lineId', e.target.value)} />
                </div>
                <div>
                    <div className="flex justify-between text-sm font-bold mb-2">
                        <p className="">銀行名稱</p>
                        {/* <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={editBankName}
                            label=""
                            required
                            className="w-full mb-6"
                            onChange={e => setEditBankName(e.target.value)}
                        >
                            <MenuItem value={"male"}>{t(`male`)}</MenuItem>
                            <MenuItem value={"female"}>{t(`female`)}</MenuItem>
                            <MenuItem value={"unknown"}>{t(`unknown`)}</MenuItem>
                        </Select> */}

                        {
                            !editBankName ?
                                <div className=" text-main4 cursor-pointer" onClick={() => setEditBankName(true)}>
                                    編輯
                                </div>
                                :
                                <div className="flex gap-2 ">
                                    <div className=" text-black6  cursor-pointer" onClick={() => setEditBankName(false)}>
                                        取消
                                    </div>
                                    <div className=" text-main4 cursor-pointer" onClick={() => updateUserInfo('bankName')}>
                                        儲存
                                    </div>
                                </div>
                        }
                    </div>
                    <input className={`input w-full ${!editBankName && " cursor-default"}`} value={data.bankName} edit readOnly={!editBankName} onChange={e => updateData('bankName', e.target.value)} />
                </div>
                <div>
                    <div className="flex justify-between text-sm font-bold mb-2">
                        <p className="">銀行帳號</p>
                        {
                            !editBankNumber ?
                                <div className=" text-main4 cursor-pointer" onClick={() => setEditBankNumber(true)}>
                                    編輯
                                </div>
                                :
                                <div className="flex gap-2 ">
                                    <div className=" text-black6  cursor-pointer" onClick={() => setEditBankNumber(false)}>
                                        取消
                                    </div>
                                    <div className=" text-main4 cursor-pointer" onClick={() => updateUserInfo('bankNumber')}>
                                        儲存
                                    </div>
                                </div>
                        }
                    </div>
                    <input className={`input w-full ${!editBankNumber && " cursor-default"}`} value={data.bankNumber} edit readOnly={!editBankNumber} onChange={e => updateData('bankNumber', e.target.value)} />
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">是否為協談者？ （中大盤以上）</p>
                    <div className="input w-full" >
                        {userInfo.isNegotiator ? '是' : '否'}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">是否為講師？（大盤以上）</p>
                    <div className="input w-full" >
                        {userInfo.isLecturer ? '是' : '否'}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">推薦人</p>
                    <div className="input w-full" >
                        {userInfo?.referralUser?.name}
                    </div>
                </div>
                <div>
                    <p className="text-sm font-bold mb-2">輔導者（大盤）</p>
                    <div className="input w-full" >
                        {userInfo.isLecturer ? '是' : '否'}
                    </div>
                </div>

            </div>
        }
    </div>

}

export default Home